import { render, staticRenderFns } from "./tabArrivalInformationUICustom.vue?vue&type=template&id=d1f36b04&"
import script from "./tabArrivalInformationUICustom.vue?vue&type=script&lang=js&"
export * from "./tabArrivalInformationUICustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1f36b04')) {
      api.createRecord('d1f36b04', component.options)
    } else {
      api.reload('d1f36b04', component.options)
    }
    module.hot.accept("./tabArrivalInformationUICustom.vue?vue&type=template&id=d1f36b04&", function () {
      api.rerender('d1f36b04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaImport/components/SiBooking/tabs/tabArrivalInformationUICustom.vue"
export default component.exports